import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function BudgetAlertsWidget({ budgetAlertsSummary, cardClass = '' }) {
  const navigate = useNavigate();
  const alerts = budgetAlertsSummary?.alerts || [];
  const counts = budgetAlertsSummary?.counts || {};
  const total = budgetAlertsSummary?.total_active || 0;

  return (
    <Card className={`${cardClass} overflow-hidden`} data-testid="widget-budget-alerts">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="font-outfit text-base flex items-center gap-2">
            <AlertTriangle size={16} className="text-warning" />
            Budget Alerts
            {total > 0 && (
              <Badge className="bg-error/20 text-error border-error/30 text-[10px] ml-1">{total}</Badge>
            )}
          </CardTitle>
          <Button size="sm" variant="ghost" className="text-xs" onClick={() => navigate('/budget-vs-actual')}>View All</Button>
        </div>
      </CardHeader>
      <CardContent>
        {total === 0 ? (
          <div className="text-center py-6 text-muted-foreground text-sm">
            <AlertTriangle size={24} className="mx-auto mb-2 opacity-40" />
            <p>No active budget alerts</p>
            <p className="text-xs mt-1">Configure thresholds in Budget vs Actual page</p>
          </div>
        ) : (
          <div className="space-y-2">
            {alerts.slice(0, 5).map((alert) => (
              <div key={alert.id} className={`flex items-center justify-between p-2.5 rounded-lg border text-sm ${
                alert.severity === 'exceeded' ? 'bg-error/10 border-error/30' :
                alert.severity === 'critical' ? 'bg-warning/10 border-warning/30' :
                'bg-warning/10 border-warning/30'
              }`}>
                <div className="flex items-center gap-2 min-w-0">
                  <div className={`w-2 h-2 rounded-full shrink-0 ${
                    alert.severity === 'exceeded' ? 'bg-error' :
                    alert.severity === 'critical' ? 'bg-warning' : 'bg-warning'
                  }`} />
                  <span className="font-medium truncate">{alert.category}</span>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className={`font-bold text-xs ${
                    alert.severity === 'exceeded' ? 'text-error' :
                    alert.severity === 'critical' ? 'text-warning' : 'text-warning'
                  }`}>{alert.percentage}%</span>
                  <span className="text-[10px] text-muted-foreground">{(alert.actual || 0).toLocaleString()} / {(alert.budgeted || 0).toLocaleString()}</span>
                </div>
              </div>
            ))}
            {counts && (
              <div className="flex gap-2 mt-2 pt-2 border-t border-border">
                {counts.exceeded > 0 && <Badge className="bg-error/20 text-error border-error/30 text-[10px]">{counts.exceeded} exceeded</Badge>}
                {counts.critical > 0 && <Badge className="bg-warning/20 text-warning border-warning/30 text-[10px]">{counts.critical} critical</Badge>}
                {counts.warning > 0 && <Badge className="bg-warning/20 text-warning border-warning/30 text-[10px]">{counts.warning} warning</Badge>}
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
